import { BooleanInput, DateInput, required, TextInput } from 'react-admin';
import { StateInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { path } from './constants';
import { AddAddressFormProps } from '../types';
import { Container, Pair } from './styled';
import useController from './useController';

const FormContent = (props: AddAddressFormProps) => {
  const { handleAddAddress } = useController(props);

  return (
    <Container>
      <Pair>
        <TextInput source={path('address1')} label="Street" validate={required()} />
        <TextInput source={path('address2')} label="Neighborhood" />
      </Pair>
      <Pair>
        <TextInput source={path('city')} validate={required()} />
        <TextInput source={path('county')} />
      </Pair>
      <Pair>
        <StateInput label="State" include_prefix={false} source={path('state')} validate={required()} />
        <TextInput source={path('zip')} validate={required()} />
      </Pair>
      <Pair>
        <TextInput source={path('zip4')} />
        <span />
      </Pair>
      <Pair>
        <TextInput source={path('latitude')} />
        <TextInput source={path('longitude')} />
      </Pair>
      <Pair>
        <DateInput source={path('first_seen')} validate={required()} />
        <DateInput source={path('last_seen')} validate={required()} />
      </Pair>
      <BooleanInput source={path('is_current_address')} label="Set as current" defaultValue={true} />

      <DefaultToolbarStyled onClose={props.onClose} onSave={handleAddAddress} saveButtonLabel="Add" />
    </Container>
  );
};

export default FormContent;
